import { SCAN_LIST_FAILURE, SCAN_LIST_REQUEST, SCAN_LIST_SUCCESS } from "../constants/scanListConstants";


const initialState = {
  loading: false,
  scans: [],
  totalCount: 0,
  error: null
};

const scanListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCAN_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SCAN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        scans: action.payload.response || [],
        totalCount: action.payload.pagination?.totalItems || 0,
        error: null
      };
    case SCAN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default scanListReducer;